module.exports = __webpack_public_path__ + "static/media/shirt.4c559e9d.svg";